import { render, staticRenderFns } from "./SurveyResults.vue?vue&type=template&id=be9bc2de&scoped=true"
import script from "./SurveyResults.vue?vue&type=script&lang=js"
export * from "./SurveyResults.vue?vue&type=script&lang=js"
import style0 from "./SurveyResults.vue?vue&type=style&index=0&id=be9bc2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9bc2de",
  null
  
)

export default component.exports